// cSpell:ignore Afrekeningen Eindafrekening gebouw Gebouw Gemeenschappelijk huurders kost pand panden Privaat verdeeld voor
// The Type column's header with a small "?" after it (Lewis, 2026-10-18):
// its tooltip says what each type means, one line per type, the term first.
// For a cost (the cost list and the settlement's summary):
//
//   Gemeenschappelijk   Een kost van het gebouw (…), verdeeld over de panden. …
//   Privaat             Een kost van één pand (…), voor de huurders van dat pand. …
//
// For a settlement (the Afrekeningen list): Gebouw, Privaat and
// Eindafrekening. The "?" is reachable by keyboard (see InfoTip).

import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import React from "react";
import styled from "styled-components";
import type { IInfoRow } from "../provisionMonthsHint.utils";
import { InfoTip } from "../scenes/SettlementInfo/SettlementForm/steps/InfoTip";

export type TTypeColumnKind = "cost" | "settlement";

// Each type's term and the key of its explanation (the header's key with
// ".help.<type>").
const TYPE_HELP: Record<TTypeColumnKind, { term: string; help: string }[]> = {
  cost: [
    { term: "costs.label.common", help: "costs.list.column.type.help.common" },
    {
      term: "costs.label.private",
      help: "costs.list.column.type.help.private",
    },
  ],
  settlement: [
    {
      term: "costs.label.building",
      help: "costs.list.column.type.help.settlement_group",
    },
    {
      term: "costs.label.private",
      help: "costs.list.column.type.help.settlement_private",
    },
    {
      term: "settlement.title.departure_short",
      help: "costs.list.column.type.help.settlement_departure",
    },
  ],
};

// "Type" and its "?" on one line.
const Header = styled.span`
  white-space: nowrap;
`;

export const typeColumnHelpRows = (kind: TTypeColumnKind): IInfoRow[] =>
  TYPE_HELP[kind].map(({ term, help }) => ({
    label: getLocalizedText(term),
    value: getLocalizedText(help),
  }));

export const TypeColumnHeader: React.FC<{ kind: TTypeColumnKind }> = ({
  kind,
}) => (
  <Header>
    {getLocalizedText("costs.list.column.type")}
    <InfoTip help rows={typeColumnHelpRows(kind)} />
  </Header>
);
